<script lang="ts">
	import type { Snippet } from 'svelte';
	import { TabNavContext, setTabNavContext } from './tabs.context.svelte';

	interface Props {
		activeTab: string;
		onchange?: (id: string) => void;
		children: Snippet;
		autoHideLabels?: boolean;
		orientation?: 'horizontal' | 'vertical' | 'responsive';
		mode?: 'button' | 'href';
		baseURL?: string;
	}
	let {
		activeTab,
		onchange,
		children,
		autoHideLabels,
		orientation = 'horizontal',
		mode = 'button',
		baseURL: baseUrl
	}: Props = $props();

	const ctx = new TabNavContext();
	$effect(() => {
		ctx.activeTab = activeTab;
		ctx.onchange = onchange;
		ctx.mode = mode;
		ctx.baseURL = baseUrl;
		ctx.orientation = orientation;
		ctx.autoHideLabels = autoHideLabels;
	});
	setTabNavContext(ctx);
</script>

<div class:autoHideLabels class="tab-nav-container {orientation}">
	<nav>{@render children()}</nav>
</div>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.tab-nav-container {
		@include lib.flex-row();
		font-size: 0.875rem;
		display: contents;

		@mixin verticalAlignment {
			width: auto;
			min-width: 200px;
			nav {
				@include lib.flex-column();
				@include lib.flex-align(flex-start, stretch);
				background: transparent;
				border-radius: 0;
				padding: 0;
				flex: 1 1 auto;
			}
		}

		&.vertical {
			@include verticalAlignment();
			nav {
				gap: 0.25rem;
			}
		}
		&.autoHideLabels {
			container-type: inline-size;
		}
		// The container is display: contents, so the padding goes on the nav.
		&.responsive nav {
			padding: 0 1rem;
		}
		@include lib.bp(gt-xs) {
			width: fit-content;
			max-width: 100%;
			&.responsive {
				@include verticalAlignment();
			}
		}
		nav {
			@include lib.flex-row();
			@include lib.flex-align();
			gap: 0.5rem;
			overflow-x: auto;

			@include lib.bp(gt-xs) {
				overflow: hidden;
			}
		}
	}
</style>
